'use client';

import { useState } from 'react';
import { apiService, parseApiError } from '@/lib/api-client';

export interface UseFavoritesReturn {
  toggleFavorite: (auctionId: string, isCurrentlyFavorite: boolean) => Promise<boolean>;
  isLoading: boolean;
  error: string | null;
}

export const useFavorites = (): UseFavoritesReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const toggleFavorite = async (auctionId: string, isCurrentlyFavorite: boolean): Promise<boolean> => {
    try {
      setIsLoading(true);
      setError(null);

      let response;
      if (isCurrentlyFavorite) {
        // Remove from favorites
        response = await apiService.favorites.removeFavorite({ auctionId });
      } else {
        // Add to favorites
        response = await apiService.favorites.addFavorite({ auctionId });
      }

      if (response.isSuccess) {
        return !isCurrentlyFavorite; // Return new favorite status
      } else {
        setError(response.message || 'Favori işlemi başarısız');
        return isCurrentlyFavorite; // Return current status on error
      }
    } catch (error) {
      const parsedError = parseApiError(error, 'Favori işlemi sırasında bir hata oluştu');
      setError(parsedError.message);
      return isCurrentlyFavorite; // Return current status on error
    } finally {
      setIsLoading(false);
    }
  };

  return {
    toggleFavorite,
    isLoading,
    error
  };
};
